import { createAction, props } from '@ngrx/store';

import {
  Document,
  DocumentCreate,
  DocumentTag,
} from '@lockton-apps/shared/interfaces';

import { DocumentsApiActionTypes } from './actions.model';

export const loadTagsSuccess = createAction(
  DocumentsApiActionTypes.LoadTagsSuccess,
  props<{ tags: DocumentTag[] }>()
);

export const loadTagsFailure = createAction(
  DocumentsApiActionTypes.LoadTagsFailure,
  props<{ error: any }>()
);

export const loadPolicyDocumentsSuccess = createAction(
  DocumentsApiActionTypes.LoadPolicyDocumentsSuccess,
  props<{ documents: Document[] }>()
);

export const loadPolicyDocumentsFailure = createAction(
  DocumentsApiActionTypes.LoadPolicyDocumentsFailure,
  props<{ error: any }>()
);

export const folderDocumentsLoadedSuccess = createAction(
  DocumentsApiActionTypes.FolderDocumentsLoadedSuccess,
  props<{ documents: Document[] }>()
);

export const folderDocumentsLoadedFailure = createAction(
  DocumentsApiActionTypes.FolderDocumentsLoadedFailure,
  props<{ error: any }>()
);

export const documentUploadedSuccess = createAction(
  DocumentsApiActionTypes.DocumentUploadedSuccess,
  props<{
    document: Document;
    queue: DocumentCreate[];
    success?: Document[];
    failed?: DocumentCreate[];
  }>()
);

export const documentUploadedFailure = createAction(
  DocumentsApiActionTypes.DocumentUploadedFailure,
  props<{
    queue: DocumentCreate[];
    success?: Document[];
    failed?: DocumentCreate[];
    error: any;
  }>()
);

export const documentsUploadCompleted = createAction(
  DocumentsApiActionTypes.DocumentUploadCompleted,
  props<{ success: Document[]; failed: DocumentCreate[] }>()
);

export const documentUpdatedSuccess = createAction(
  DocumentsApiActionTypes.DocumentUpdatedSuccess
);

export const documentUpdatedFailure = createAction(
  DocumentsApiActionTypes.DocumentUpdatedFailure
);

export const downloadSuccess = createAction(
  DocumentsApiActionTypes.DownloadSuccess,
  props<{ file: Blob; name?: string }>()
);

export const downloadFailure = createAction(
  DocumentsApiActionTypes.DownloadFailure,
  props<{ error: any }>()
);

export const deletedSuccess = createAction(
  DocumentsApiActionTypes.DeletedSuccess
);

export const deletedFailure = createAction(
  DocumentsApiActionTypes.DeletedFailure
);
